/**
 * 지도 레이어(OpenLayers)에서 Vuetify 테마 색을 쓸 때 사용.
 * --v-* 변수는 document.documentElement가 아니라 .v-application에 주입되므로
 * 여기서 읽어야 라이트/다크 전환과 일치한다.
 *
 * main.css의 --solvit-map-* 는 레이어별 오버라이드용(선택).
 */
export function getVuetifyThemeVar(name, fallback = '') {
  if (typeof document === 'undefined') return fallback;
  const root = document.querySelector('.v-application') || document.documentElement;
  const v = getComputedStyle(root).getPropertyValue(name).trim();
  return v || fallback;
}

/** IR 열화상 폴리곤(전체 레이어·선택 사각형 공통) 스트로크/채움 기준색 */
export function getIrMapStrokeColor() {
  const mapped = getVuetifyThemeVar('--solvit-map-ir-stroke', '');
  return mapped || getVuetifyThemeVar('--v-error-base', '#C62828');
}

/** RGB 촬영 영역 폴리곤(WFS rgb_image_feature_catalog) — main.css --solvit-map-rgb-stroke 로 조정 */
export function getRgbMapStrokeColor() {
  const mapped = getVuetifyThemeVar('--solvit-map-rgb-stroke', '');
  return mapped || getVuetifyThemeVar('--v-info-base', '#1565C0');
}
